import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import {
  ActionsModalComponent,
  ActionsModalRole
} from '../../shared/actions-modal/actions-modal.component';
import * as Sentry from '@sentry/angular';
import { ActionsModalDto } from '../../dto/shared.dto';

@Injectable({
  providedIn: 'root'
})
export class AcceptOrderModalService {
  constructor(private modalCtrl: ModalController) {}

  public async acceptOrderModal(confirmAction: () => Promise<void>): Promise<ActionsModalRole> {
    try {
      const modal = await this.modalCtrl.create({
        component: ActionsModalComponent,
        breakpoints: [0, 1],
        initialBreakpoint: 1,
        componentProps: {
          data: {
            confirmAction,
            confirmButton: true,
            confirmButtonText: 'Принять заявку',
            message: `Если вы примите заявку в работу, то она станет недоступной для других пользователей системы.
            Хотите принять заявку в работу?`,
            title: 'Принять заявку в работу?',
            imageSrc: '../../../assets/images/take-in-work.svg',
            expeditorTerms: true
          } as ActionsModalDto
        }
      });
      await modal.present();

      const { role } = await modal.onDidDismiss<null>();
      return (role ?? 'cancel') as ActionsModalRole;
    } catch (err) {
      Sentry.captureException(err);
      return 'cancel';
    }
  }
}
